import { combineReducers } from 'redux';
import { taskBoardReducer } from 'data/task-board';
import { companiesReducer } from 'stores/companies';
import { fieldsReducer } from 'stores/fields';
import { membershipsReducer } from 'stores/memberships';
import { permissionSetsReducer } from 'stores/permission-sets';
import { teamsReducer } from 'stores/teams';
import { usersReducer } from 'stores/users';
import { visibilitySettingsReducer } from 'stores/visibility';
import { accountReducer } from './account';
import { creditNoteReducer } from './credit-notes';
import { currentUserProfileReducer } from './current-user-profile';
import { documentsReducer } from './documents';
import { stateName as taskFieldsStateName, taskFieldsReducer } from './fields';
import { homeReducer, homeStateName } from './home';
import { invoiceReducer } from './invoices';
import { layoutReducer } from './layout';
import { membersReducer } from './members/slice';
import { personalTasksReducer } from './personal-tasks';
import { spaceTabsReducer } from './space-tabs';
import { spacesReducer } from './spaces';
import { sprintsReducer } from './sprints/slice';
import { teamPlannerReducer } from './team-planner';
import { templatesReducer } from './templates';
export const createRootReducer = ()=>combineReducers({
        documents: documentsReducer,
        members: membersReducer,
        currentUserProfile: currentUserProfileReducer,
        personalTasks: personalTasksReducer,
        spaces: spacesReducer,
        layout: layoutReducer,
        spaceTabs: spaceTabsReducer,
        templates: templatesReducer,
        memberships: membershipsReducer,
        accountVisibilitySettings: visibilitySettingsReducer,
        permissionSets: permissionSetsReducer,
        users: usersReducer,
        teams: teamsReducer,
        fields: fieldsReducer,
        companies: companiesReducer,
        [taskFieldsStateName]: taskFieldsReducer,
        [homeStateName]: homeReducer,
        taskBoard: taskBoardReducer,
        account: accountReducer,
        sprints: sprintsReducer,
        teamPlanner: teamPlannerReducer,
        invoice: invoiceReducer,
        creditNote: creditNoteReducer
    });
